import { reportError } from './reporter'

const reportUncaughtException = (message, url, lineNumber, columnNumber, error) =>
  reportError(message, {
    columnNumber,
    lineNumber,
    stack: error ? error.stack : undefined,
    url,
  })

const reportValidationError = (message, eventName, payload) =>
  reportError('event:validation:failed', {
    error: {
      message,
    },
    eventName,
    payload,
  })

const reportTrackerFailure = (error, eventName, payload) =>
  reportError('tracker:failed', {
    error: {
      message: error.message || error,
      readyState: error.readyState,
      status: error.status,
    },
    eventName,
    payload,
  })

const reportUnsuccessfulRequest = ({ body, error }) =>
  reportError('api:call:failed', { body, error })

const reportAPIFailure = (error, payload) => {
  // Status Code from Authentication API specification:
  // https://confluence.internal.babbel.com/x/7JqRCw

  // Error data structure
  // error: {
  //   status: (int) 4XX,
  //   code: (string) 'mock_error',
  //   title: (string) 'Mock Error',
  //   detail: (string) 'Error is error'
  // }

  /*
   * The request was made but no response was received,
   * `error.request` is either an instance of XMLHttpRequest
   * or `error` is a generic error
   */

  if (error.status >= 500) {
    return reportUnsuccessfulRequest({ body: payload, error })
  }

  return null
}

const reportCaptchaError = (message, payload) =>
  reportError('captcha:validation:failed', {
    error: {
      message,
    },
    payload,
  })

export {
  reportAPIFailure,
  reportCaptchaError,
  reportTrackerFailure,
  reportUncaughtException,
  reportValidationError,
}
export { reportWarning } from './reporter'
